export default __webpack_public_path__ + "static/media/dottedBGSmall.8d6eefbc.png";